/* eslint-disable jsx-a11y/anchor-is-valid */

import { useCallback, useEffect, useState } from 'react';
import { useSelector, useStore } from 'react-redux';

// reducers
import { selectCountry } from 'hyc-store/reducers/countries/countriesReducer';
import { selectDistribution, resetDistribution, updateDistribution } from 'hyc-store/reducers/distribution';

// functions
import { useToggle } from 'shared/functions';

// components
import { ListTable } from './list-table';
import { SelectYear } from 'shared/components';
import { SelectMonth } from 'shared/components';

import * as helper from './helper';

const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
const TABS = ['Week 1', 'Week 2', 'Week 3', 'Week 4'];

const ShipmentLists = () => {
    const store = useStore();
    const country = useSelector(selectCountry);
    const { month, year, today } = useSelector(selectDistribution);

    const [customers, setCustomers] = useState([]);
    const [week, setWeek] = useState('Week 1');

    const [loading, setLoading] = useToggle(false);
    const [activeTab, setActiveTab] = useState(week);

    const getShipmentLists = useCallback(async () => {
        setLoading();
        const results = await helper.getShipmentList(year, month, week, country);
        setCustomers(results)
        setLoading();

    }, [month, country, year, week, setLoading])

    const handlePickOption = (option) => {
        store.dispatch(updateDistribution({ month: option }));
    }

    const handleYear = (event) => {
        store.dispatch(updateDistribution({ year: event.target.value }));
    }

    const handleTabChange = (tab) => {
        setActiveTab(tab);
        setWeek(tab);
    }

    const Tabs = () => (
        <div className="tabs is-large is-fullwidth">
            <ul>
                {TABS.map((tab) => (
                    <li key={tab} className={tab === activeTab ? 'is-active' : ''}>
                        <a onClick={() => handleTabChange(tab)}>{tab}</a>
                    </li>
                ))}
            </ul>
        </div>
    );

    const reset = useCallback(() => {
        store.dispatch(resetDistribution());
    }, [store]);

    const update = useCallback(({ year, month }) => {
        store.dispatch(updateDistribution({
            year: year,
            month: month
        }));
    }, [store]);

    useEffect(() => {
        if (new Date(today).getDate() !== new Date().getDate()) {
            reset();
        }

        if (month === null) {
            const todayDate = new Date(today);
            update({
                year: todayDate.getFullYear(), month: MONTHS[todayDate.getMonth()]
            })
        };

        getShipmentLists();

    }, [reset, update, month, today, getShipmentLists]);

    return (
        <div className="container">

            <nav className="level">
                <div className="level-right">

                    <div className="level-item">
                        <div>
                            <h1 className="title">Shipment Lists</h1>
                            <h2 className="heading is-2">From here, you can see and filter the customers in the next shipment lists!</h2>
                        </div>
                    </div>

                </div>
            </nav>
            <div className="columns">
                <div className="column">

                    <div className="columns is-vcentered">
                        <div className="column is-2">
                            <SelectYear onChange={handleYear} year={year} />
                        </div>
                        <div className="column is-3">
                            <SelectMonth onChange={handlePickOption} month={month} months={MONTHS} />
                        </div>
                    </div>

                </div>
                <div className="column is-6">
                    <Tabs />
                </div>
            </div>
            {loading && <progress className="mt-4 progress is-small is-primary" max="100">15%</progress>}

            {!loading && <ListTable customers={customers} />}


        </div>
    );
}

export { ShipmentLists };
